import bulkPageChanges from './bulk-page-changes';
import changeHTML from './change-html';
import copyElement from './copy-element';
import deleteElement from './delete-element';
import duplicateElement from './duplicate-element';
import insertBlock from './insert-block';
import insertElement from './insert-element';
import replaceElement from './replace-element';
import shiftElement from './shift-element';
import removeElementAttribute from './remove-element-attribute';
import setElementAttribute from './set-element-attribute';
import setInlineElementStyle from './set-inline-element-style';
import synchronizeElement from './synchronize-element';
import blurFocusedElement from './blur-focused-element';
import pasteElement from './paste-element';
import scroll from './scroll';
import disableView from './disable-view';
import viewStatusChanger from './view-status-changer';
import setChildrenPresence from './set-children-presence';
import viewReloader from './view-reloader';
import updateAtomicCSS from './update-atomic-css';

export default {
  bulkPageChanges,
  changeHTML,
  copyElement,
  pasteElement,
  deleteElement,
  duplicateElement,
  insertBlock,
  insertElement,
  replaceElement,
  shiftElement,
  viewReloader,
  removeElementAttribute,
  setElementAttribute,
  setInlineElementStyle,
  synchronizeElement,
  blurFocusedElement,
  scroll,
  disableView,
  viewStatusChanger,
  setChildrenPresence,
  updateAtomicCSS,
};
